import React, { useState, useEffect, useRef } from 'react';
import { IonModal, IonIcon, IonButton, IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';
import { close } from 'ionicons/icons';
import { FormatDate, FormatTime, TimeFormat } from '../../../defines/Functions';
import { Constants } from '../../../defines/Constants';
import { Pagination } from 'react-rainbow-components';
import CurrencyFormat from 'react-currency-format';
import './FlightHotelChangeFlight.css';
import planeImg from '../../../assets/images/flight-card-plane.svg';
import Loading from '../../Loading';
import FlightFilter from './FlightFilter';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    data: any,
    activeFlight: any,
    activeFlightParentCallback: Function
}
const FlightHotelChangeFlight = (props: Props) => {
    const showRemoveFilter = useRef(false);
    const [loading, setLoading] = useState(false);
    const [flightData, setFlightData] = useState(props.data) as any;
    const [state, setState] = useState({
        showFlightHotelChangeFlightModal: false,
        totalPages: 1,
        activePage: 1,
        activeFlight: props.activeFlight,
        activePrice: 0,
        filters: {
            routeWent: {
                airlinesRouteWent: [] as any,
                stopsRouteWent: [],
                timesRouteWent: [] as any,
                durationRouteWent: {
                    lower: 0,
                    upper: 0
                }
            },
            routeReturn: {
                airlinesRouteReturn: [] as any,
                stopsRouteReturn: [],
                timesRouteReturn: [] as any,
                durationRouteReturn: {
                    lower: 0,
                    upper: 0
                }
            },
            ticketPrice: {
                lower: 0,
                upper: 0
            }
        },
        errorMessage: ''
    });
    const handleData = function (data: any) {
        // setSearchData(data);
        if (data.pricedItineraries) {
            let pricedItinerariesData = data.pricedItineraries.pricedItinerary;
            let totalAmount, equivFareAmount, discountAmount, discountPercent;
            let itineraryItems = [] as any;
            if (Object.keys(state.filters.routeWent.airlinesRouteWent).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].operatingAirline.code;
                    let foundItem = state.filters.routeWent.airlinesRouteWent.filter((element: any) => {
                        return itemSearchEl === element.code;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (Object.keys(state.filters.routeWent.timesRouteWent).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl: number;
                    let myTime = TimeFormat(item.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime);
                    myTime = myTime.replace(':', '.');
                    if (myTime < 8) {
                        itemSearchEl = 1;
                    } else if (myTime < 11 && myTime >= 8) {
                        itemSearchEl = 2;
                    } else if (myTime < 14 && myTime >= 11) {
                        itemSearchEl = 3;
                    } else if (myTime < 17 && myTime >= 14) {
                        itemSearchEl = 4;
                    } else if (myTime < 21 && myTime >= 17) {
                        itemSearchEl = 5;
                    } else if (myTime >= 21) {
                        itemSearchEl = 6;
                    }
                    let foundItem = state.filters.routeWent.timesRouteWent.filter((element: any) => {
                        return itemSearchEl === element.value;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (Object.keys(state.filters.routeReturn.airlinesRouteReturn).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl = item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].operatingAirline.code;
                    let foundItem = state.filters.routeReturn.airlinesRouteReturn.filter((element: any) => {
                        return itemSearchEl === element.code;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            if (Object.keys(state.filters.routeReturn.timesRouteReturn).length !== 0) {
                showRemoveFilter.current = true;
                pricedItinerariesData = pricedItinerariesData.filter((item: any) => {
                    let itemSearchEl: number;
                    let myTime = TimeFormat(item.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime);
                    myTime = myTime.replace(':', '.');
                    if (myTime < 8) {
                        itemSearchEl = 1;
                    } else if (myTime < 11 && myTime >= 8) {
                        itemSearchEl = 2;
                    } else if (myTime < 14 && myTime >= 11) {
                        itemSearchEl = 3;
                    } else if (myTime < 17 && myTime >= 14) {
                        itemSearchEl = 4;
                    } else if (myTime < 21 && myTime >= 17) {
                        itemSearchEl = 5;
                    } else if (myTime >= 21) {
                        itemSearchEl = 6;
                    }
                    let foundItem = state.filters.routeReturn.timesRouteReturn.filter((element: any) => {
                        return itemSearchEl === element.value;
                    });
                    return (foundItem.length ? true : false);
                })
            }
            let totalPages = Math.ceil(pricedItinerariesData.length / perPage);
            [].concat(pricedItinerariesData).forEach((itinerary: any) => {
                totalAmount = itinerary.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount;
                equivFareAmount = itinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount;
                discountAmount = totalAmount - equivFareAmount;
                discountPercent = (discountAmount * 100 / totalAmount);
                itinerary.discountPercentage = discountPercent;
                itineraryItems.push(itinerary);
            });
            let obj = {
                pricedItineraries: {
                    pricedItinerary: itineraryItems
                },
                targetName: data.targetName
            }
            setFlightData(obj);
            setState({ ...state, totalPages: totalPages, activePage: 1, errorMessage: totalPages === 0 ? 'نتیجه ای یافت نشد!' : '' });
            setLoading(false);
        } else {
            setFlightData({});
        }
    }
    useEffect(() => {
        handleData(props.data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showFlightHotelChangeFlightModal, props.data, state.filters])
    useEffect(() => {
        setState({ ...state, activePrice: props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.activeFlight.airItineraryPricingInfo.itinTotalFare]);
    let perPage = 10;
    const setPage = (event: any, page: any) => {
        setState({ ...state, activePage: page });
    }
    const lastItem = state.activePage * perPage;
    const firstItem = lastItem - perPage;
    let flightHotelChangeCard = null;
    flightHotelChangeCard = flightData.pricedItineraries.pricedItinerary.slice(firstItem, lastItem).map((pricedItinerary: any, pricedItineraryIndex: number) =>
        <div className={pricedItinerary.sequenceNumber === state.activeFlight.sequenceNumber ? 'flight-hotel-change-flight-card is-active' : 'flight-hotel-change-flight-card'} key={'index' + pricedItineraryIndex}>
            <IonGrid>
                {pricedItinerary.airItinerary.originDestinationOptions.originDestinationOption.map((item: any, index: number) =>
                    <IonRow className="row-1" key={'index' + index}>
                        <IonCol size="2" className="col ion-text-center">
                            <IonImg src={Constants.airlines + item.flightSegment[0].operatingAirline.code + '.png'} />
                            <span>
                                {item.flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                    item.flightSegment[0].tpaextensions.any[0].airlinePersian
                                ) : (
                                    item.flightSegment[0].operatingAirline.companyShortName
                                )}
                            </span>
                        </IonCol>
                        <IonCol size="3" className="col ion-text-center">
                            <h5>
                                {FormatTime(item.flightSegment[0].departureDateTime, "hh:mm")}
                            </h5>
                            <span>
                                {item.flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                    item.flightSegment[0].tpaextensions.any[0].departureCityPersian
                                ) : (
                                    item.flightSegment[0].tpaextensions.any[0].departureCity
                                )}
                            </span>
                        </IonCol>
                        <IonCol size="4" className="col ion-text-center">
                            <span>
                                {item.flightSegment.length === 1 ? (
                                    'بدون توقف'
                                ) : (
                                    item.flightSegment.length - 1 + ' - توقف'
                                )}
                            </span>
                            <IonImg src={planeImg} />
                            <span>
                                {FormatDate(item.flightSegment[0].departureDateTime, 'jD jMMMM')}
                            </span>
                        </IonCol>
                        <IonCol size="3" className="col ion-text-center">
                            <h5>
                                {FormatTime(item.flightSegment[item.flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                            </h5>
                            <span>
                                {item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                    item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                ) : (
                                    item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                )}
                            </span>
                        </IonCol>
                    </IonRow>
                )}
                <IonRow>
                    <IonCol size="6" className="ion-text-center">
                        <div>
                            {(pricedItinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount - state.activePrice) > 0 ?
                                <b>
                                    افزایش قیمت
                                </b>
                                : (pricedItinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount - state.activePrice) < 0 ?
                                    <b>
                                        کاهش قیمت
                                    </b>
                                    : (pricedItinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount - state.activePrice) === 0 ?
                                        <b>
                                            بدون تفاوت نرخ
                                        </b>
                                        :
                                        null
                            }
                            <b>
                                <CurrencyFormat value={(pricedItinerary.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount) - state.activePrice} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                            </b>
                        </div>
                    </IonCol>
                    <IonCol size="6">
                        <IonButton color="warning" expand="block" onClick={() => { selectFlight(pricedItinerary) }}>
                            انتخاب
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div>
    )
    const handleFlightFilterCallback = (childData: any) => {
        let airlinesRouteWentArray = [] as any;
        let timesRouteWentArray = [] as any;
        let airlinesRouteReturnArray = [] as any;
        let timesRouteReturnArray = [] as any;
        Object.entries(childData.routeWent.airlinesRouteWent).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            airlinesRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeWent.timesRouteWent).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            timesRouteWentArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.airlinesRouteReturn).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            airlinesRouteReturnArray.push(item[1]);
        });
        Object.entries(childData.routeReturn.timesRouteReturn).filter(([k, v]: any) => v.checked === true).forEach((item) => {
            timesRouteReturnArray.push(item[1]);
        });
        setState({
            ...state,
            filters:
            {
                routeWent: {
                    airlinesRouteWent: airlinesRouteWentArray,
                    stopsRouteWent: [],
                    timesRouteWent: timesRouteWentArray,
                    durationRouteWent: { lower: 0, upper: 0 }
                },
                routeReturn: {
                    airlinesRouteReturn: airlinesRouteReturnArray,
                    stopsRouteReturn: [],
                    timesRouteReturn: timesRouteReturnArray,
                    durationRouteReturn: { lower: 0, upper: 0 }
                },
                ticketPrice: { lower: 0, upper: 0 },
            }
        });
    }
    const selectFlight = (item: any) => {
        setLoading(true);
        setState({ ...state, activeFlight: item, activePrice: item.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount });
        props.activeFlightParentCallback(item);
        setTimeout(() => {
            setLoading(false);
        }, 100);
    }
    const removeFilter = () => {
        setState({
            ...state, filters: {
                routeWent: {
                    airlinesRouteWent: [] as any,
                    stopsRouteWent: [],
                    timesRouteWent: [] as any,
                    durationRouteWent: {
                        lower: 0,
                        upper: 0
                    }
                },
                routeReturn: {
                    airlinesRouteReturn: [] as any,
                    stopsRouteReturn: [],
                    timesRouteReturn: [] as any,
                    durationRouteReturn: {
                        lower: 0,
                        upper: 0
                    }
                },
                ticketPrice: {
                    lower: 0,
                    upper: 0
                }
            }
        });
        showRemoveFilter.current = false;
    }
    return (
        <>
            <IonModal isOpen={state.showFlightHotelChangeFlightModal} onDidDismiss={() => setState({ ...state, showFlightHotelChangeFlightModal: false })} mode="ios" cssClass="flight-hotel-change-flight-modal">
                <div className="flight-hotel-change-flight-modal-content">
                    <h3 className="flight-hotel-change-flight-modal-title">
                        تغییر پرواز
                        <IonIcon icon={close} onClick={() => setState({ ...state, showFlightHotelChangeFlightModal: false })} />
                    </h3>
                    {state.errorMessage.trim() !== '' ?
                        <div className="flight-hotel-change-flight-box-error">
                            <div className="box-error">
                                <IonImg src={warningSign} />
                                <p>{state.errorMessage}</p>
                            </div>
                        </div>
                        : !loading ?
                            <div className="flight-hotel-change-flight-modal-items">
                                <div className="flight-hotel-change-flight-card active">
                                    <IonGrid>
                                        {state.activeFlight.airItinerary.originDestinationOptions.originDestinationOption.map((item: any, index: number) =>
                                            <IonRow className="row-1" key={'index' + index}>
                                                <IonCol size="2" className="col ion-text-center">
                                                    <IonImg src={Constants.airlines + item.flightSegment[0].operatingAirline.code + '.png'} />
                                                    <span>
                                                        {item.flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                                            item.flightSegment[0].tpaextensions.any[0].airlinePersian
                                                        ) : (
                                                            item.flightSegment[0].operatingAirline.companyShortName
                                                        )}
                                                    </span>
                                                </IonCol>
                                                <IonCol size="3" className="col ion-text-center">
                                                    <h5>
                                                        {FormatTime(item.flightSegment[0].departureDateTime, "hh:mm")}
                                                    </h5>
                                                    <span>
                                                        {item.flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                                            item.flightSegment[0].tpaextensions.any[0].departureCityPersian
                                                        ) : (
                                                            item.flightSegment[0].tpaextensions.any[0].departureCity
                                                        )}
                                                    </span>
                                                </IonCol>
                                                <IonCol size="4" className="col ion-text-center">
                                                    <span>
                                                        {item.flightSegment.length === 1 ? (
                                                            'بدون توقف'
                                                        ) : (
                                                            item.flightSegment.length - 1 + ' - توقف'
                                                        )}
                                                    </span>
                                                    <IonImg src={planeImg} />
                                                    <span>
                                                        {FormatDate(item.flightSegment[0].departureDateTime, 'jD jMMMM')}
                                                    </span>
                                                </IonCol>
                                                <IonCol size="3" className="col ion-text-center">
                                                    <h5>
                                                        {FormatTime(item.flightSegment[item.flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                                                    </h5>
                                                    <span>
                                                        {item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                                            item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                                        ) : (
                                                            item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                                        )}
                                                    </span>
                                                </IonCol>
                                            </IonRow>
                                        )}
                                        <IonRow>
                                            <IonCol size="6" className="ion-text-center">
                                                <b>
                                                    <CurrencyFormat value={state.activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                </b>
                                            </IonCol>
                                            <IonCol size="6">
                                                <IonButton color="warning" expand="block">
                                                    انتخاب شده
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </div>
                                {state.totalPages > 0 &&
                                    <React.Fragment>
                                        {flightHotelChangeCard}
                                        <div className="my-pagination">
                                            <span>صفحه {state.activePage} از {state.totalPages}</span>
                                            {state.totalPages > 1 &&
                                                <Pagination
                                                    pages={state.totalPages}
                                                    activePage={state.activePage}
                                                    onChange={setPage}
                                                />
                                            }
                                        </div>
                                        <div className="total-records">
                                            تعداد پرواز های یافت شده : {flightData.pricedItineraries.pricedItinerary.length} پرواز
                                        </div>
                                    </React.Fragment>
                                }
                                {showRemoveFilter.current &&
                                    <IonButton color="danger" expand="block" onClick={() => { removeFilter() }} className="remove-filters-btn">
                                        حذف فیلترها
                                    </IonButton>
                                }
                            </div>
                            :
                            <Loading />
                    }
                </div>
                <div className="flight-hotel-change-flight-footer-btns">
                    <FlightFilter
                        data={flightData}
                        flightFilterParentCallback={handleFlightFilterCallback}
                        filters={state.filters}
                        searchType="roundtrip"
                        disabled={false}
                        type="flightHotel"
                    />
                    <IonButton color="primary" onClick={() => setState({ ...state, showFlightHotelChangeFlightModal: false })} className="flight-filter-modal-close-btn">
                        ادامه فرایند خرید
                    </IonButton>
                </div>
            </IonModal>
            <IonButton color="primary" fill="outline" expand="block" onClick={() => setState({ ...state, showFlightHotelChangeFlightModal: true })}>
                تغییر پرواز
            </IonButton>
        </>
    );
};
export default FlightHotelChangeFlight;